'use client';

import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { NavPayloadAction } from '@carvana/merch-native';
import { datadogRum } from '@datadog/browser-rum';
import { ReactNode, useContext } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';

type OwnProps = {
  bodyStyleKey: string;
  children: ReactNode;
  url: string;
};

export default function VehicleCardLink({
  bodyStyleKey,
  children,
  url
}: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);

  const onClick = () => {
    datadogRum.addAction(DATADOG_EVENTS.PREQUALIFIED.CLICKS_BODYSTYLE, {
      bodyStyle: bodyStyleKey
    });
    trackEvent(ANALYTICS_EVENTS.PREQUALIFIED.CLICKS_BODYSTYLE, {
      bodyStyle: bodyStyleKey
    });
  };

  return (
    <a
      data-analytics-id={`Financing ${bodyStyleKey} Vehicle Card Link`}
      data-native-payload={JSON.stringify({ action: NavPayloadAction.ViewSrp })}
      href={url}
      onClick={onClick}
      data-testid="vehicle-card"
    >
      {children}
    </a>
  );
}
